module.exports = __webpack_public_path__ + "img/extended.7da12bcf.png";